<script setup lang="ts">
import { useDialogPluginComponent } from 'quasar';

const props = withDefaults(defineProps<{
  aFileId: string;
  validationErrors?: string[];
  title?: string;
  errorsLabel?: string;
  fileName?: string;
}>(), {
  title: 'Should I send it to Merit anyway?',
  errorsLabel: 'Validation errors:',
});

const { dialogRef, onDialogHide, onDialogOK } = useDialogPluginComponent();

const onConfirmClick = () => {
  onDialogOK({
    aFileId: props.aFileId,
    forceSubmit: true,
  });
};

</script>
<template>
  <q-dialog
    ref="dialogRef"
    persistent
    @hide="onDialogHide"
  >
    <q-card
      class="q-pa-md"
      style="min-width: 400px"
    >
      <q-card-section>
        <div class="text-h6">
          {{ props.title }}
        </div>
        <div
          v-if="props.fileName"
          class="text-body2 text-grey-8 q-mt-xs ellipsis"
        >
          {{ props.fileName }}
        </div>
      </q-card-section>

      <q-card-section v-if="props.validationErrors && props.validationErrors?.length">
        <div class="text-subtitle1 q-mb-sm text-grey-dark">
          {{ props.errorsLabel }}
        </div>
        <q-list
          bordered
          separator
          class="rounded-borders"
        >
          <q-item
            v-for="(err, idx) in props.validationErrors"
            :key="idx"
          >
            <q-item-section side>
              <q-icon
                name="error_outline"
                color="negative"
              />
            </q-item-section>
            <q-item-section>
              <div class="text-body2">
                {{ err }}
              </div>
            </q-item-section>
          </q-item>
        </q-list>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn
          v-close-popup
          flat
          no-caps
          label="Cancel"
          color="primary"
        />
        <q-btn
          flat
          no-caps
          label="Proceed"
          color="primary"
          @click="onConfirmClick"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
